// Web/no-op variant. On web, notification taps are handled by the service
// worker's `notificationclick` handler (see public/firebase-messaging-sw.js),
// which opens the clickAction URL directly — React Navigation is not involved.
// Metro resolves useNotificationNavigation.native.ts for the native build.
export const useNotificationNavigation = (
  _onNavigate: (url: string) => void,
): void => {
  // Intentionally empty on web.
};
